import { ITermsDuration } from '../../../../../../../types/reducers/termsDurations';

export const getActiveDurationIdx = (durations: ITermsDuration[], activeDurationDays: number): number | undefined => {
  const activeDuration = durations.find(({ durationInDays }) => durationInDays === activeDurationDays);

  if (!activeDuration) {
    return undefined;
  }

  return durations.indexOf(activeDuration);
};
